import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { toNormalizedASCIIStr } from '../../utils/string';
import Text from '../Text';

const StyledText = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.autoComplete.text};
    text-decoration: none;
  `}
`;

function TextMatch({ children, currInputValue }) {
  const normalizedChild = toNormalizedASCIIStr(children.trim()).toLowerCase();
  const normalizedCurrInputValue = toNormalizedASCIIStr(
    currInputValue.trim()
  ).toLowerCase();

  if (
    currInputValue.length === 0 ||
    normalizedChild !== normalizedCurrInputValue
  ) {
    return <StyledText as="span">{children}</StyledText>;
  }

  return (
    <StyledText as="span" bold>
      {children}
    </StyledText>
  );
}

TextMatch.propTypes = {
  children: PropTypes.string.isRequired,
  currInputValue: PropTypes.string.isRequired,
};

export default TextMatch;
